const templateRecycleColumns = [
    {
        title: "编号",
        dataIndex: "code",
        width: "260px",
        ellipsis: true,
        key: "code"
    },
    {
        title: "缩略图",
        dataIndex: "thumb",
        ellipsis: true,
        width: "100px",
        key: "thumb",
        scopedSlots: {customRender: "thumb"}
    },
    {
        title: "颜色",
        dataIndex: "color_name",
        ellipsis: true,
        width: "90px",
        key: "color_name"
    },
    {
        title: "行业",
        dataIndex: "industry_name",
        width: "130px",
        ellipsis: true,
        key: "industry_name"
    },
    {
        title: "定制客户",
        dataIndex: "customized_customer_name",
        width: "230px",
        ellipsis: true,
        key: "customized_customer_name"
    },
    {
        title: "设计师",
        dataIndex: "designer_name",
        width: "100px",
        ellipsis: true,
        key: "designer_name"
    },
    {
        title: "模板类型",
        dataIndex: "type_text",
        width: "100px",
        ellipsis: true,
        key: "type_text"
    },
    {
        title: "删除时间",
        dataIndex: "delete_time",
        width: "150px",
        ellipsis: true,
        key: "delete_time"
    },
    {
        title: "操作",
        key: "action",
        width: "200px",
        scopedSlots: {customRender: "action"}
    }
]

export default templateRecycleColumns
